const ROUTE_TICKET = process.env.REACT_APP_ROUTE_TICKET_URL;
export const createErrorLog = `${ROUTE_TICKET}api/front-error-log`;
